import { render, staticRenderFns } from "./NewProfessional.vue?vue&type=template&id=de34cd6c"
import script from "./NewProfessional.vue?vue&type=script&lang=js"
export * from "./NewProfessional.vue?vue&type=script&lang=js"
import style0 from "./NewProfessional.vue?vue&type=style&index=0&id=de34cd6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports